"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.querystringToObj = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isInIframe = () => {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInIframe = isInIframe;
const isInPopup = () => {
    return exports.isBrowser() && !!window.opener;
};
exports.isInPopup = isInPopup;
const querystringToObj = (query) => {
    var _a, _b;
    let qs = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : "";
    if (qs.startsWith("?")) {
        qs = qs.substr(1);
    }
    qs = decodeURIComponent(qs);
    var chunks = qs.split("&"), obj = {};
    for (var c = 0; c < chunks.length; c++) {
        var split = chunks[c].split("=", 2);
        obj[split[0]] = split[1];
    }
    return obj;
};
exports.querystringToObj = querystringToObj;
